import React from 'react';
import { TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { useSelector } from 'react-redux';
import { SummaryLabelledInfo } from '../labelled-info';
import { SummaryTable } from '../table';
import {
  OfficialCeoLabel,
  RepresentativeLabel,
  signAuthorities,
} from '../../../representatives/representatives-utils';
import { RadioConvertUtils } from '../../../../../../utils/radio/radio';
import { BuyProcessState } from '../../../../buy-process-form-types';
import { SignAuthority } from '../../../../../../global/entities/BuyOrder';
import {
  selectBuyCeoPersonFactory,
  selectBuyRepresentativesPeopleFactory,
} from '../../../../../../services/buy-process/selectors';

interface SummaryRepresentativesProps {
  representatives: BuyProcessState['representatives'];
  orderId: string;
}

export const SummaryRepresentatives = ({
  representatives,
  orderId,
}: SummaryRepresentativesProps) => {
  const representativesColumns = [
    'Samtliga förnamn',
    'Efternamn',
    'Personnummer',
    'Utdelningsadress',
    'Postnummer',
    'Ort',
    'Funktion',
  ];

  const { signAuthority, officialCeo, signAuthorityUserDefined } = representatives;

  const isOfficialCeo = (
    officialCeo: boolean,
    ceoType: typeof ceo,
  ): ceoType is any => officialCeo;

  const people = useSelector(selectBuyRepresentativesPeopleFactory(orderId));
  const ceo = useSelector(selectBuyCeoPersonFactory(orderId));

  return (
    <React.Fragment>
      <SummaryLabelledInfo isTable label="Styrelse">
        <SummaryTable columns={representativesColumns}>
          {people.map((x, index) => (
            <TableRow key={index}>
              <TableCell>{x.firstName}</TableCell>
              <TableCell>{x.lastName}</TableCell>
              <TableCell>{x.socialSecurityNumber}</TableCell>
              <TableCell>{x.address}</TableCell>
              <TableCell>{x.postalCode}</TableCell>
              <TableCell>{x.city}</TableCell>
              {x.relationType && (
                <TableCell>{RepresentativeLabel[x.relationType]}</TableCell>
              )}
            </TableRow>
          ))}
        </SummaryTable>
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Utse Verkställande Direktör?">
        {OfficialCeoLabel[RadioConvertUtils.boolToStr(officialCeo)]}
      </SummaryLabelledInfo>

      {isOfficialCeo(officialCeo, ceo) && (
        <>
          <SummaryLabelledInfo label="Samtliga förnamn">
            {ceo?.firstName}
          </SummaryLabelledInfo>
          <SummaryLabelledInfo label="Efternamn">
            {ceo?.lastName}
          </SummaryLabelledInfo>
          <SummaryLabelledInfo label="Personnummer">
            {ceo?.socialSecurityNumber}
          </SummaryLabelledInfo>
          <SummaryLabelledInfo label="Utdelningsadress">
            {ceo?.address}
          </SummaryLabelledInfo>
          <SummaryLabelledInfo label="Postnummer">
            {ceo?.postalCode}
          </SummaryLabelledInfo>
          <SummaryLabelledInfo label="Ort">{ceo?.city}</SummaryLabelledInfo>
        </>
      )}

      <SummaryLabelledInfo label="Firmateckning">
        {signAuthority === SignAuthority.ABX
          ? signAuthorityUserDefined
          : signAuthorities[signAuthority]}
      </SummaryLabelledInfo>
    </React.Fragment>
  );
};
